import { render, staticRenderFns } from "./SubscriberView.vue?vue&type=template&id=2fda6310&lang=pug"
import script from "./SubscriberView.vue?vue&type=script&lang=ts"
export * from "./SubscriberView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports